<alert></alert>
<router-outlet></router-outlet>
<app-footer></app-footer>